var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{ref:"modal",staticClass:"modal_main",attrs:{"title":"HD Addresses"}},[_c('div',{staticClass:"hd_deriv_modal_body"},[_c('HDDerivationList',{attrs:{"wallet":_vm.wallet}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }